import { getInitializer } from '@websolutespa/bom-mixer-llm';
import { llmPlugin } from './plugin';

export * from './blocks';
export * from './components';
export * from './llm';
export * from './mock';
export * from './plugin';

const initializer = getInitializer('llmEFG', [llmPlugin]);

export type LlmPlugin = typeof initializer;
